// extracted by mini-css-extract-plugin
module.exports = {"contactLabel":"ChatContacts_contactLabel__2gZy0","contactList":"ChatContacts_contactList__9Fsne","spin360":"ChatContacts_spin360__1Qyfd"};